import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SingleFeature from '../../components/Feature';
import SectionTitle from '../../components/SectionTitle';

const features = [
  { icon: 'flaticon-coach', title: 'Work Based Learning', description: 'Spend part of every week learning at a real workplace.', to: '/about-us' },
  { icon: 'flaticon-coding', title: 'English And IT', description: 'Both are taught alongside your degree, from the first year.', to: '/facilities' },
  { icon: 'flaticon-location', title: 'Green Campus', description: 'Study on a quiet, tree-covered hill in Kegalle.', to: '/facilities' },
  { icon: 'flaticon-funds', title: 'Fair Fees', description: 'A fair fee, plus a government interest-free loan option.', to: '/faq' },
  { icon: 'flaticon-certificate', title: 'Lateral Entry', description: 'Working people with a recognised qualification can join.', to: '/faq' },
  { icon: 'flaticon-teacher', title: 'Student Support', description: 'Two senior lecturers act as student counsellors.', to: '/facilities' },
];

const ServiceTwoMain = () => {
  return (
    <main>
      <Breadcrumb title="Why Study Here" subTitle="Why SANASA" />

      <div className="it-feature-3-area it-feature-3-bg inner-style pt-120 pb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-7 col-md-8">
              <SectionTitle
                itemClass="it-feature-3-title-box text-center mb-60 section-title-fixed-width"
                subTitleClass="ed-section-subtitle"
                subTitle="Why SANASA Campus"
                titleClass="it-section-title-3"
                title="Six Reasons To Study With Us"
              />
            </div>
          </div>
          <div className="row">
            {features.map((f) => (
              <div key={f.title} className="col-xl-4 col-lg-6 col-md-6">
                <SingleFeature
                  icon={f.icon}
                  title={f.title}
                  description={f.description}
                  to={f.to}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};
export default ServiceTwoMain;
